import { Tooltip } from "@blueprintjs/core";
import React from "react";

import { IconNames } from "@blueprintjs/icons/lib/esm";
import { BlockView } from "common/views/block/BlockView.view";
import { BoxView } from "common/views/box/Box.view";
import { ImageView } from "common/views/image/Image.view";
import { RowsView } from "common/views/rows/Rows.view";
import { IQueryOne, QueryOne } from "core/api/query";
import { IPanelProps, Panel } from "core/decorators/Panel";
import OrganizationFlaggedUsers from "panels/organizations/admin/discussion/entities/OrganizationFlaggedUsers";
import Config from "./Config";
import  labelProvider  from './OrganizationFlaggedUsers.labels';

const {Labels} = labelProvider;

@Panel({id: "organizations-flagged-users", configClass: Config, pageParams: true})
@QueryOne(OrganizationFlaggedUsers, {})
export default class OrganizationsFlaggedUsers extends React.PureComponent<IPanelProps<Config> & IQueryOne<OrganizationFlaggedUsers>> {

		// This better be a number between 1 and 100. I aint got time to error check.
		// https://media0.giphy.com/media/bWM2eWYfN3r20/giphy.gif
		private getRandomCompletion(min, max) {
				return (Math.random() * (max - min) + min);
		}

	public render() {
				const { config, entity } = this.props;

				const userCards = (entity && entity.userList) && this.props.entity.userList.map((user, index) => {

												const src: string = (user.avatar && user.avatar.file && user.avatar.file.url) || "https://placehold.it/80x80";

												const actions: any[] = [
																		{
																				text: <Labels.OpenUser/>,
																				icon: IconNames.PLAY,
																				onClick: () => alert(`Open ${name}!`)
																		}
																];
												return(
																		<div key={index}>
																						<BlockView viewKey="flagged-user-block">
																								<ImageView
																												src={src}
																												viewKey="avatar-thumbnail"
																								/>
																								<div><h2>{user.firstName} {user.lastName}</h2></div>
																								<div><span>{this.getRandomCompletion(1, 10)} {config.flaggedText}</span></div>
																						</BlockView>
																</div>
												);
								});

				return (

						<BoxView title={config.flaggedTitle} viewKey="organization-flagged-users-box">
								<RowsView viewKey="organization-flagged-users-rows">
										{userCards}
								</RowsView>
						</BoxView>
				);
	}
}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/discussion/OrganizationFlaggedUsers.panel.tsx